import type { RadioGroupProps } from '@mui/material';

import StyledCatalogRadioGroup from './CatalogRadioGroup.styles';

const CatalogRadioGroup: React.FC<RadioGroupProps> = ({
  className,
  ...props
}) => {
  return <StyledCatalogRadioGroup className={className} {...props} />;
};

export default CatalogRadioGroup;
